import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CerrixLabelComponent } from "../../atoms/cerrix-label/cerrix-label.component";
import { CerrixSelectComponent } from "@app/shared/atoms/cerrix-select/cerrix-select.component";
import { CerrixInstructionsIconComponent } from "@app/shared/cerrix-instructions-icon/cerrix-instructions-icon.component";

@Component({
    selector: "app-cerrix-select-group",
    imports: [CerrixSelectComponent, CerrixLabelComponent, CerrixInstructionsIconComponent],
    templateUrl: "./cerrix-select-group.component.html",
    styleUrl: "./cerrix-select-group.component.scss",
})
export class CerrixSelectGroupComponent {
    @Input() placeholder: string = "";
    @Input() disabled: boolean = false;
    @Input() infoText: string = "";
    @Input() required: boolean = false;
    @Input() name: string = "";
    @Input() options: { label: string; value: string }[] = [];
    @Input() selectedValue: string | null | undefined = null;
    @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();
}
